// extracted by mini-css-extract-plugin
export default {"list":"contactsList_list__kbkzm","item":"contactsList_item__3+aKF","btn":"contactsList_btn__Gf5pN"};